import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function CalendarSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-5 w-64 mt-2" />
        </div>
        <div className="flex items-center gap-4">
          <Skeleton className="h-10 w-[200px]" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-10 w-20" />
            <Skeleton className="h-10 w-10" />
          </div>
        </div>
      </div>

      {/* Week grid skeleton */}
      <Card>
        <CardContent className="p-0">
          {/* Day headers */}
          <div className="grid grid-cols-7 border-b">
            {Array.from({ length: 7 }).map((_, i) => (
              <div key={i} className="p-3 text-center border-r last:border-r-0">
                <Skeleton className="h-4 w-8 mx-auto" />
                <Skeleton className="h-6 w-6 mx-auto mt-1" />
              </div>
            ))}
          </div>

          {/* Day cells */}
          <div className="grid grid-cols-7 min-h-[400px]">
            {Array.from({ length: 7 }).map((_, dayIndex) => (
              <div key={dayIndex} className="p-2 border-r last:border-r-0 space-y-2">
                {Array.from({ length: 2 }).map((_, i) => (
                  <Skeleton key={i} className="h-20 w-full rounded-lg" />
                ))}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Legend skeleton */}
      <Card>
        <CardHeader className="py-3">
          <Skeleton className="h-5 w-16" />
        </CardHeader>
        <CardContent className="py-3">
          <div className="flex flex-wrap gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <Skeleton key={i} className="h-6 w-20" />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
